// Accès Firebase pour la couche de services, avec l'API modulaire du SDK.
//
// L'app est initialisée par src/components/Firebase/firebase.js avec l'API « compat ». En Firebase 12, compat et
// modulaire ne demandent pas l'instance Firestore sous le même identifiant (« [DEFAULT] » contre « (default) ») :
// getFirestore(getApp()) créerait une SECONDE instance, sans les réglages (émulateurs) ni le cache de la première.
// On réutilise donc les instances modulaires que l'API compat enveloppe (_delegate), pour n'avoir qu'une connexion.
// À simplifier quand plus aucun composant n'utilisera l'API compat.
import app from 'firebase/compat/app';

export const db = () => app.firestore()._delegate;
export const storage = () => app.storage()._delegate;
